<template>
    <div>
        <v-app class="p-4">
            <div class="col-md-12 p-0 mt-5 pt-10 mx-auto" style="border: none!important;">
                <v-card-title>
                    <wallet-open-button/>

                    <router-link to="/divarNews/new">
                        <v-btn class="btn-add-with-text">
                            <span class="fa fa-plus ml-1"></span>
                            افزودن تازه های دیوار
                        </v-btn>
                    </router-link>
                </v-card-title>
                <!--      start edit mode -->
                <template>
                    <v-row justify="center">
                        <v-dialog
                                v-if="relatedModal"
                                v-model="relatedModal"
                                max-width="1200"
                                hide-overlay
                                transition="dialog-bottom-transition"
                        >
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >

                                    <v-toolbar-title class="pl-2"> آگهی های یافت شده</v-toolbar-title>
                                    ({{ adsCount }})
                                    <v-spacer></v-spacer>
                                    <div class="d-flex">
                                        <v-toolbar-items>
                                            <v-btn
                                                    icon
                                                    dark
                                                    @click="relatedModal = false"
                                            >
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </v-toolbar-items>
                                    </div>
                                </v-toolbar>
                                <divar-advertise class="py-4" :id="related_id" :searchResults="myRes"></divar-advertise>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
                <!--      end edit mode -->

                <v-tabs v-model="tab" color="deep-purple accent-4" class="mt-5" grow>
                    <v-tab v-for="item in TabsName" :key="item.value">{{ item.name }}</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-card v-if="tab === 0" :loading="loading" class="p-3 pt-0">
                            <terminal-table class="col-12" :currentPage="datas.current_page"
                                            :perPage="datas.per_page" v-if="isMobile" :getData="getDataForTable"
                                            :pageCount="datas.last_page"
                                            :options="tableProps" :datas="datas" :headers="columns"></terminal-table>
                            <data-table
                                    v-else
                                    :data="datas"
                                    :columns="columns"
                                    :debounce-delay="3000"
                                    :pagination="paginate"
                                    :orderBy="tableProps.column"
                                    :orderDir="tableProps.dir"
                                    :translate="translate"
                                    :per-page="[10, 25, 50, 100, 500]"
                                    @on-table-props-changed="reloadTable"
                                    class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
                            ></data-table>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <all-posts v-if="tab === 1"></all-posts>
                    </v-tab-item>
                </v-tabs-items>

            </div>
        </v-app>
    </div>
</template>

<script>
import SimilarAds from "@/view/pages/divar/divarNews/similarAds";
import {dataTableProps} from "@/main";
import {debounce} from "../../../../custom";
import button from "../../button";
import DivarAdvertise from "./divarAdvertise";
import AllPosts from "./allPosts";
import WalletOpenButton from "../../../../view/content/wallet/WalletOpenButton";


export default {
    name: "divarNewsList",
    components: {WalletOpenButton, AllPosts, DivarAdvertise, SimilarAds},
    data() {
        return {
            tarafeName: "",
            TabsName: [{name: 'لیست تازه های دیوار', value: 'list'}, {name: 'آگهی های یافت شده', value: 'post'}],
            tab: "",
            authModal: false,
            loading: false,
            adsModal: false,
            relatedModal: false,
            related_id: null,
            adsCount: '',
            datas: {},
            mine: [],
            myRes: [],
            activeComponent: '',
            translate: dataTableProps.translate,
            tableProps: dataTableProps.tableProps,
            paginate: dataTableProps.pagination,
            url: `${url}/user/recent`,
            selectedNumber: [],
            dataId: '',
            adsList: '',
            columns: [
                {
                    label: '<input type="checkbox" id="selectAll">',
                    isCheckBox: true,
                    transform: (val) => {
                        return `<input type="checkbox"  data-id="${val.data.phone}">`
                    },
                    orderable: false,
                },
                {
                    label: 'ردیف',
                    transform: (val) => {
                        let row = this.datas.current_page - 1;
                        row = row * this.datas.per_page;
                        return row + val.row + 1;
                    },
                    orderable: true,
                },
                {
                    label: 'شناسه',
                    name: 'id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'نام مستعار',
                    name: 'title',
                },
                {
                    label: 'کلمه کلیدی',
                    name: 'keyword',
                    transform: (val) => {
                        return val.data.keyword ? val.data.keyword : '-';
                    },
                },
                {
                    label: 'شهر',
                    name: 'city',
                    primary: true,
                    transform: (val) => {
                        return this.translator("city_" + val.data.city);
                    },
                },
                {
                    label: 'نام دسته',
                    name: 'category',
                    primary: true,
                    transform: (val) => {
                        return this.translator(val.data.category);
                    },
                },
                {
                    label: 'زمان ایجاد',
                    name: 'created_at',
                    transform: (val) => {
                        return val.data.created_at ? val.data.created_at : '-'
                    },
                },
                {
                    label: 'آخرین فعالیت',
                    name: 'updated_at_diff',
                    transform: (val) => {
                        return val.data.updated_at_diff ? val.data.updated_at_diff : '-'
                    },
                },
                {
                    label: 'تعداد دریافت شده',
                    name: 'count',
                    transform: (val) => {
                        return val.data.count ? val.data.count : '0'
                    },
                },
                {
                    label: 'مدیریت',
                    name: 'action',
                    component: button,
                    event: "actions",
                    meta: {
                        buttons: [
                            {
                                name: 'disable',
                                label: 'غیرفعال',
                                icon: 'fa fa-times',
                                class: 'btn-outline',
                                action: this.actions,
                                condition(data) {
                                    return !data.is_deleted;
                                }
                            },
                            {
                                name: 'restore',
                                label: 'فعال',
                                icon: 'fa fa-check',
                                class: 'btn-outline-success',
                                action: this.actions,
                                condition(data) {
                                    return data.is_deleted;
                                }
                            },
                            {
                                name: 'delete',
                                label: 'حذف',
                                icon: 'trash-alt',
                                class: 'btn-outline-danger',
                                action: this.actions,
                                condition(data) {
                                    return data.is_deleted;
                                }
                            },
                            {
                                name: 'related',
                                label: 'آگهی های مرتبط',
                                icon: 'list',
                                class: 'btn-outline-primary',
                                action: this.actions,
                            },
                        ]
                    }
                },
            ],
            updatedData: [],
            authResult: [],
        }
    },
    methods: {
        translator(name) {
            return this.translates[name];
        },
        getDataForTable(url = this.url, query = this.tableProps) {
            const vm = this;
            vm.loading = true;
            $.ajax({
                url: url,
                type: 'GET',
                fn: this.getDataForTable,
                data: query,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: function (data) {
                    vm.datas = data.data;
                    vm.loading = false;
                }
            })
        },
        reloadTable(tableProps) {
            debounce(() => {
                this.getDataForTable(this.url, tableProps);
            }, 700);
        },
        actions(data, type) {
            this[type + "Action"](data);
        },
        deleteAction(data) {
            this.$modal.yesNo('تایید حذف', 'آیا از حذف این دسته اطمینان دارید؟', "neg", '').then((value => {
                if (value === true) {
                    $.ajax({
                        url: `${url}/user/recent/${data.id}/force`,
                        method: 'DELETE',
                        msg: true,
                        fn: this.deleteAction,
                        headers: {
                            "ACCEPT": "application/json",
                            "Authorization": Token
                        },
                        success: (val) => {
                            this.reloadTable();
                        },
                    });
                }
            }));
        },
        restoreAction(data) {
            this.$modal.yesNo('تایید فعال کردن', 'آیا از فعال کردن این لیست اطمینان دارید؟', "neg", '').then((value => {
                if (value === true) {
                    $.ajax({
                        url: `${url}/user/recent/${data.id}/restore`,
                        method: 'PUT',
                        msg: true,
                        fn: this.deleteAction,
                        headers: {
                            "ACCEPT": "application/json",
                            "Authorization": Token
                        },
                        success: (val) => {
                            this.reloadTable();
                        },
                    });
                }
            }));
        },
        disableAction(data) {
            this.$modal.yesNo('تایید غیرفعال کردن', 'آیا از غیرفعال کردن این لیست اطمینان دارید؟', "neg", '').then((value => {
                if (value === true) {
                    $.ajax({
                        url: `${url}/user/recent/${data.id}`,
                        method: 'DELETE',
                        msg: true,
                        fn: this.deleteAction,
                        headers: {
                            "ACCEPT": "application/json",
                            "Authorization": Token
                        },
                        success: (val) => {
                            this.reloadTable();
                        },
                    });
                }
            }));
        },
        relatedAction: function (data) {
            this.relatedModal = true;
            this.adsCount = data.assessed
            this.related_id = data.id
        },
        allowOnlyNumbers(value) {
            if (typeof Number(value.key) !== 'string') {
                let allowedKeys = [8, 46, 38, 40, 37, 39];
                const keypressed = value.which || value.keyCode;
                if (/[^0-9\s]+/.test(value.key)) {
                    if (allowedKeys.every(e => e !== keypressed)) {
                        value.preventDefault();
                    }
                } else return true
            }
        },
        getLocalization() {
            $.ajax({
                url: `${url}/setting/localization`,
                type: 'GET',
                fn: this.getLocalization,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    console.log(data)
                    this.translates = data.data
                    localStorage.setItem('localization', JSON.stringify(data.data));
                }
            })
        },
        refreshIt() {
            this.getDataForTable(this.url);
            this.tab = 0
        }
    },
    mounted() {
        this.getDataForTable(this.url);
        this.getLocalization();
        $(document).on('click', '#selectAll', (element) => {
            if ($(element.target).is(':checked')) {
                $('input[type="checkbox"]').prop('checked', true);

                const selected = $('input[type="checkbox"]').map(function () {
                    return $(this).data('id')
                }).get();

                this.selectedNumber = selected;
            } else {
                $('input[type="checkbox"]').prop('checked', false)
                this.selectedNumber = []
            }
        });
    },
    computed: {
        isMobile() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    this.getDataForTable(this.url);
                    return true
                case 'sm':
                    this.getDataForTable(this.url);
                    return true
                case 'md':
                    this.getDataForTable(this.url);
                    return false
                case 'lg':
                    this.getDataForTable(this.url);
                    return false
                case 'xl':
                    this.getDataForTable(this.url);
                    return false
            }
        },
    },
    watch: {
        tab: function (val) {
            if (val === 0) {
                this.reloadTable();
            }
        }
    }
}
</script>

<style scoped>

</style>